<template>
  <div class="flex flex-row justify-between p-1 align-baseline">
    <div class="flex flex-col">
      <p class="text-xs text-gray-700">
        {{ item.item.name[$i18n.locale] }}
      </p>
      <p
        v-if="item?.item?.ref?.length > 0"
        class="text-xs font-light text-slate-300"
      >
        {{ item.item.ref }}
      </p>
    </div>
    <div>
      <p class="text-xs flex">
        <span v-if="item.is_custom_pricing">
        <FontAwesomeIcon
          :icon="['fas', 'star-of-life']"
          class="ml-1"
        /></span></p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
  name: 'PackItemModalCard',
  components: {FontAwesomeIcon},
  props: {
    item: {
      type: Object,
      required: true
    },
    priceEncodingType: {
      type: String,
      required: false,
      default: 'HTVA'
    }
  },
  computed: {
    ...mapGetters({ initialMetadata: 'metadata/getInitialMetadata' }),
    displayedPrice() {
      if (this.initialMetadata.settings.price_encoding_type === 'HTVA') {
        return ` ${this.$h.formatCurrency(
          this.item.price_htva
        )}`
      } else if (this.initialMetadata.settings.price_encoding_type === 'TVAC') {
        return ` ${this.$h.formatCurrency(
          this.item.price_tvac
        )}`
      }
      return null
    }
  }
}
</script>
